import { render } from "./Situ.vue?vue&type=template&id=2c69d5f6&scoped=true"
import script from "./Situ.vue?vue&type=script&lang=js"
export * from "./Situ.vue?vue&type=script&lang=js"

import "./Situ.vue?vue&type=style&index=0&id=2c69d5f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c69d5f6"]])

export default __exports__